var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/reply-mentions.tsx";
import React, { useCallback } from 'react';
import { FormattedList, FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { openModal } from 'soapbox/actions/modals';
import { useAppSelector, useCompose } from 'soapbox/hooks';
import { statusToMentionsAccountIdsArray } from 'soapbox/reducers/compose';
import { makeGetStatus } from 'soapbox/selectors';
import { getFeatures } from 'soapbox/utils/features';

const ReplyMentions = _ref => {
  let {
    composeId
  } = _ref;
  const dispatch = useDispatch();
  const getStatus = useCallback(makeGetStatus(), []);
  const compose = useCompose(composeId);
  const instance = useAppSelector(state => state.instance);
  const status = useAppSelector(state => getStatus(state, {
    id: compose.in_reply_to
  }));
  const to = compose.to;
  const account = useAppSelector(state => state.accounts.get(state.me));
  const {
    explicitAddressing
  } = getFeatures(instance);

  if (!explicitAddressing || !status || !to) {
    return null;
  }

  const parentTo = status && statusToMentionsAccountIdsArray(status, account);

  const handleClick = e => {
    e.preventDefault();
    dispatch(openModal('REPLY_MENTIONS', {
      composeId
    }));
  };

  if (!parentTo || parentTo.size === 0) {
    return null;
  }

  if (to.size === 0) {
    return /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "reply-mentions",
      onClick: handleClick,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reply_mentions.reply_empty",
      defaultMessage: "Replying to post",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 9
      }
    }));
  }

  const accounts = to.slice(0, 2).map(acct => /*#__PURE__*/React.createElement("span", {
    className: "reply-mentions__account",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 5
    }
  }, "@", acct.split('@')[0])).toArray();

  if (to.size > 2) {
    accounts.push( /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reply_mentions.more",
      defaultMessage: "{count} more",
      values: {
        count: to.size - 2
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 7
      }
    }));
  }

  return /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "reply-mentions",
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reply_mentions.reply",
    defaultMessage: "Replying to {accounts}",
    values: {
      accounts: /*#__PURE__*/React.createElement(FormattedList, {
        type: "conjunction",
        value: accounts,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 21
        }
      })
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 7
    }
  }));
};

export default ReplyMentions;